/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Input,
  Table,
} from 'antd';

import InfoView from 'components/common/InfoView';
import {
  fetchUserMerchantAccounts,
  setSelectedMerchantAccount,
} from '../../redux/actions/Data';
import { merchantColumns } from '../../components/common/Columns';
import ProfileDetails from '../Profile/ProfileDetails';
import { getSelectedUser } from '../../redux/actions/Auth';

const UserMerchantAccounts = () => {
  const dispatch = useDispatch();
  const { userId } = useParams();
  const history = useHistory();
  const {
    data: merchants,
    loading,
    currentPage: current,
    pageSize,
    totalItems,
  } = useSelector(({ data }) => data.userMerchantAccounts);
  const selectedUser = useSelector(({ auth }) => auth.selectedUser);

  useEffect(() => {
    if (userId) {
      dispatch(fetchUserMerchantAccounts(userId));
      if (!selectedUser || selectedUser._id !== userId) {
        dispatch(getSelectedUser(userId));
      }
    }
  }, [dispatch]);

  const handleOnChange = (pagination, filters, sorter) => {
    let query = '';
    if (pagination && Object.keys(pagination).length) {
      query += `&page=${pagination.current}&limit=${pagination.pageSize}`;
    }
    if (filters && Object.keys(filters).length) {
      const field = Object.keys(filters)[0];
      const value = filters[field] && filters[field][0];
      const filterParams = (value !== null) ? `filter={"${field}": ${value} }` : '';
      if (field && value) {
        query += `&${filterParams}`;
      }
    }
    if (sorter && Object.keys(sorter).length && sorter.field) {
      query += `&sort={"${sorter.field}": ${sorter.order === 'ascend' ? '1' : '-1'} }`;
    }
    dispatch(fetchUserMerchantAccounts(userId, query));
  };

  const handleSearch = (searchValue) => {
    const searchFields = merchantColumns.slice(0, -2).map((row) => row.dataIndex);
    const searchParams = JSON.stringify(
      searchFields.map((field) => ({
        [field]: { $regex: searchValue.trim().replace(/([^a-zA-Z0-9])/g, '\\$1'), $options: 'i' },
      })),
    );
    const search = `filter={"$or": ${searchParams}}`;
    dispatch(fetchUserMerchantAccounts(userId, search));
  };

  const navigateToMerchantView = (record) => {
    dispatch(setSelectedMerchantAccount(record));
    history.push(`/merchant-accounts/${record._id}`);
  };

  const props = {
    loading,
    rowKey: '_id',
    columns: merchantColumns(() => {}, () => {}, navigateToMerchantView),
    dataSource: merchants,
    onChange: handleOnChange,
    pagination: {
      current,
      pageSize,
      total: totalItems,
      showSizeChanger: false,
    },
    // onRow: (record) => ({
    //   onClick: () => {
    //     navigateToMerchantView(record);
    //   },
    // }),
  };

  return (
    <div>
      <ProfileDetails selectedUser={selectedUser} />
      <h2 className="title gx-mb-3">Merchant Accounts</h2>
      <div className="justify-content-center">
        <Input.Search
          placeholder="Search merchant accounts"
          enterButton
          allowClear
          onSearch={handleSearch}
        />
        <Table className="gx-table-responsive" {...props} />
      </div>
      <InfoView />
    </div>
  );
};

export default UserMerchantAccounts;
